export const environment = {
  production: false,
  API_BASE_URL: "https://niconsultingacademy.com/"
};
